import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { preventDefault } from '@/utils/mouseEvent';

export type Props = PropsWithChildren & {
  className?: ClassNameComponent;
};

export default function CoursePathCardFooter(props: Props) {
  const { children, className } = props;

  return (
    <footer
      onClick={preventDefault}
      className={twMerge(
        'flex items-center justify-between w-full',
        className?.base,
      )}
    >
      {children}
    </footer>
  );
}
